module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4",
    class: {
      'col-md-12': _vm.fullWidth
    }
  }, [_c('fieldset', [_c('legend', [_vm._v("Load Summary")]), _vm._v(" "), _c('div', {
    staticClass: "form-group-outer"
  }, [_c('div', {
    staticClass: "form-group float-label-control",
    class: {
      'has-error': _vm.errors.has('date')
    }
  }, [_c('label', {
    staticClass: "select-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("\n            Date\n            "), (_vm.commodityChargeIsDelivery) ? [_vm._v("Delivered")] : [_vm._v("Picked Up")]], 2), _vm._v(" "), _c('date-range', {
    attrs: {
      "disabled": _vm.cannotModifyWeighbridgeDate,
      "max-date": _vm.todaysDate,
      "name": "date",
      "single-date-picker": true,
      "opens": "right"
    },
    model: {
      value: (_vm.date),
      callback: function($$v) {
        _vm.date = $$v
      },
      expression: "date"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group-outer"
  }, [_c('div', {
    staticClass: "form-group float-label-control"
  }, [_c('label', {
    staticClass: "select-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("\n            Total\n            "), (_vm.commodityChargeIsDelivery) ? [_vm._v("Delivered")] : [_vm._v("Picked Up")]], 2), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.totalTonnageOfChargeType
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("tonne")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8",
    class: {
      'col-md-12': _vm.fullWidth
    }
  }, [_c('ul', {
    staticClass: "nav nav-tabs m-b-md"
  }, [_c('li', {
    class: {
      'active': _vm.commodityChargeIsDelivery
    }
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "data-target": "#delivery"
    }
  }, [_vm._v("Delivery (" + _vm._s(_vm.numberOfDeliveryDockets) + ")")])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.commodityChargeIsPickup
    }
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "data-target": "#pickup"
    }
  }, [_vm._v("Pickup (" + _vm._s(_vm.numberOfPickupDockets) + ")")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "data-target": "#connote"
    }
  }, [_vm._v("Con-Note (" + _vm._s(_vm.numberOfConsignmentNotes) + ")")])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane",
    class: {
      'active': _vm.commodityChargeIsDelivery
    },
    attrs: {
      "id": "delivery"
    }
  }, [_vm._l((_vm.dockets.delivery), function(docket, index) {
    return _c('weighbridge-docket-item', {
      key: docket.index,
      attrs: {
        "index": index,
        "docket": docket,
        "type": "Delivery"
      }
    })
  }), _vm._v(" "), (_vm.haveNoDeliveryDockets) ? _c('div', {
    staticClass: "text-center text-muted"
  }, [_vm._v("\n          No delivery dockets.\n        ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "margin-20"
  }), _vm._v(" "), (_vm.canAddNewDockets) ? _c('a', {
    staticClass: "btn btn-info btn-xs m-b-sm",
    on: {
      "click": _vm.handleAddNewDeliveryDocket
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Add Docket\n        ")]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    class: {
      'active': _vm.commodityChargeIsPickup
    },
    attrs: {
      "id": "pickup"
    }
  }, [_vm._l((_vm.dockets.pickup), function(docket, index) {
    return _c('weighbridge-docket-item', {
      key: docket.index,
      attrs: {
        "index": index,
        "docket": docket,
        "type": "Pickup"
      }
    })
  }), _vm._v(" "), (_vm.haveNoPickupDockets) ? _c('div', {
    staticClass: "text-center text-muted"
  }, [_vm._v("\n          No pickup dockets.\n        ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "margin-20"
  }), _vm._v(" "), (_vm.canAddNewDockets) ? _c('a', {
    staticClass: "btn btn-info btn-xs m-b-sm",
    on: {
      "click": _vm.handleAddNewPickupDocket
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Add Docket\n        ")]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "id": "connote"
    }
  }, [_vm._l((_vm.dockets.consignment), function(docket, index) {
    return _c('weighbridge-consignment-item', {
      key: docket.index,
      attrs: {
        "index": index,
        "docket": docket
      }
    })
  }), _vm._v(" "), (_vm.haveNoConsignmentNotes) ? _c('div', {
    staticClass: "text-center text-muted"
  }, [_vm._v("\n          No consignment notes.\n        ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "margin-20"
  }), _vm._v(" "), (_vm.canAddNewDockets) ? _c('a', {
    staticClass: "btn btn-info btn-xs m-b-sm",
    on: {
      "click": _vm.handleAddNewConNote
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Add Con-Note\n        ")]) : _vm._e()], 2)]), _vm._v(" "), (_vm.canStoreOrUpdateWeighbridgeDetails) ? [_c('div', {
    staticClass: "margin-20"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "text-right"
  }, [_c('ladda-button', {
    staticClass: "m-b-md",
    attrs: {
      "on-click": _vm.handleSubmitWeighbridge,
      "max-width": _vm.fullWidth,
      "type": "success",
      "size": "small"
    }
  }, [_vm._v("\n              Submit Weighbridge Data\n            ")])], 1)])])] : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-9b8f58ea"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/loads/weighbridge/WeighbridgeDetails.vue
// module id = 1065
// module chunks = 0